import { createGMTDate } from "msem-lib/es/services/utils";

const CART_ID = "cartId";
const CART_BY_RESORT = "cartIds";
const STAY_DATES = "stay";
const STAY_LODGING = "lodging";
const STAY_RESORT = "resort";
const STAY_PAXPLAN = "paxplan";

export const getStartDate = (preview = false) => {
  const startDate = createGMTDate();
  startDate.setHours(0, 0, 0, 0);
  if (preview) {
    startDate.setMonth(startDate.getMonth() - 6);
  }
  return startDate;
};

export const getEndDate = () => {
  const endDate = createGMTDate();
  endDate.setHours(0, 0, 0, 0);
  endDate.setMonth(endDate.getMonth() + 12);
  return endDate;
};

export const formatDate = (intl, date) => {
  return intl.formatDate(date, { day: "numeric", month: "short" });
};

export const serializeDate = (date) => {
  const yy = date.getFullYear();
  const mm = String(date.getMonth() + 1).padStart(2, "0");
  const dd = String(date.getDate()).padStart(2, "0");
  return `${yy}-${mm}-${dd}`;
};

export const deserializeDates = (dates) => {
  const from = createGMTDate(dates.from);
  const to = createGMTDate(dates.to);
  return { from, to };
};

const readCartByResorts = () => {
  const stored = window.sessionStorage.getItem(CART_BY_RESORT);
  return JSON.parse(stored) || {};
};

const writeCartByResorts = (cartByResorts) => {
  window.sessionStorage.setItem(CART_BY_RESORT, JSON.stringify(cartByResorts));
};

export const readCartId = () => {
  const stored = window.sessionStorage.getItem(CART_ID);
  return JSON.parse(stored);
};

// export const writeCartId = (resort, cartId) => {
//   const cartByResorts = readCartByResorts();
//   if (cartId) {
//     cartByResorts[resort] = { cartId };
//     window.sessionStorage.setItem(CART_ID, JSON.stringify(cartId));
//   } else {
//     cartByResorts[resort] = undefined;
//     window.sessionStorage.removeItem(CART_ID);
//   }
//   writeCartByResorts(cartByResorts);
// };

export const removeCartId = (resort) => {
  window.sessionStorage.removeItem(CART_ID);
  const cartByResorts = readCartByResorts();
  cartByResorts[resort] = undefined;
  writeCartByResorts(cartByResorts);
};

export const syncCartId = (resort, prevResort) => {
  const cartByResorts = readCartByResorts();
  const cartId = readCartId();

  if (prevResort && cartId) {
    cartByResorts[prevResort] = { cartId };
    writeCartByResorts(cartByResorts);
  }
  if (resort !== undefined) {
    const newCartId = cartByResorts[resort];
    if (newCartId) {
      window.sessionStorage.setItem(CART_ID, JSON.stringify(newCartId.cartId));
      return newCartId.cartId;
    } else {
      window.sessionStorage.removeItem(CART_ID);
      return undefined;
    }
  }
};

export const readDates = () => {
  const stored = window.sessionStorage.getItem(STAY_DATES);
  if (!stored) return null;
  const parsed = JSON.parse(stored);
  return deserializeDates(parsed);
};

export const writeDates = (dates) => {
  if (!dates) return;
  const from = serializeDate(dates.from);
  const to = serializeDate(dates.to);
  window.sessionStorage.setItem(STAY_DATES, JSON.stringify({ from, to }));
  window.sessionStorage.removeItem(CART_ID);
};

// export const removeDates = () => {
//   window.sessionStorage.removeItem(STAY_DATES);
// };

export const readLodging = () => {
  const stored = window.sessionStorage.getItem(STAY_LODGING);
  return JSON.parse(stored);
};

export const writeLodging = (lodging) => {
  if (!lodging) return;
  window.sessionStorage.setItem(STAY_LODGING, JSON.stringify(lodging));
};

export const removeLodging = () => {
  window.sessionStorage.removeItem(STAY_LODGING);
};

export const readPaxplan = () => {
  const stored = window.sessionStorage.getItem(STAY_PAXPLAN);
  return JSON.parse(stored);
};

export const writePaxplan = (paxplan) => {
  if (!paxplan) return;
  window.sessionStorage.setItem(STAY_PAXPLAN, JSON.stringify(paxplan));
};

export const removePaxplan = () => {
  window.sessionStorage.removeItem(STAY_PAXPLAN);
};

export const readResort = () => {
  const stored = window.sessionStorage.getItem(STAY_RESORT);
  return JSON.parse(stored);
};

export const writeResort = (resort) => {
  if (!resort) return;
  window.sessionStorage.setItem(STAY_RESORT, JSON.stringify(resort));
};

// export const removeResort = () => {
//   window.sessionStorage.removeItem(STAY_RESORT);
// };

const arraysEqual = (array1, array2) =>
  array1.length === array2.length && array1.every((value, index) => value === array2[index]);

export const paxplansEqual = (prev, paxplan) => {
  return (
    prev.adults === paxplan.adults &&
    prev.children === paxplan.children &&
    arraysEqual(prev.agesChildren, paxplan.agesChildren)
  );
};
